import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FunnelPlotTwoToneSvg from "@ant-design/icons-svg/es/asn/FunnelPlotTwoTone";
import AntdIcon from '../components/AntdIcon';
var FunnelPlotTwoTone = function FunnelPlotTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: FunnelPlotTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(FunnelPlotTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'FunnelPlotTwoTone';
}
export default RefIcon;